import { pgaComTld } from "../components/utils"

export const PTM_LEGACY_APPLICATION_PATHS = [
  "/applications/associate",
  "/applications/affiliate",
  "/applications/associate/edit",
  "/applications/affiliate/edit",
]

export const MEMBER_APPLICATIONS_URL = `https://${pgaComTld}/member/account/applications`

export const shouldSuppressPtmLegacyApplicationRoute = path =>
  PTM_LEGACY_APPLICATION_PATHS.includes(path)

/**
 * Legacy Member application routes. Unlike the Associate/Affiliate paths above
 * these stay real routes unless the `applications-membership` flag is on, in
 * which case `Routes.js` redirects them to the hub. `/applications/success`
 * and `/applications/error` are the legacy forms' post-submit pages.
 *
 * Cleanup: when the redirect becomes unconditional, drop the flag branch in
 * `Routes.js`, then remove these paths from `RouteConfig.js` together with
 * `src/components/Applications`.
 */
export const MEMBER_LEGACY_APPLICATION_PATH = "/applications/membership"

export const MEMBER_LEGACY_APPLICATION_PATHS = [
  MEMBER_LEGACY_APPLICATION_PATH,
  "/applications/membership/edit",
  "/applications/success",
  "/applications/error",
]

export const isMemberLegacyApplicationPath = path =>
  MEMBER_LEGACY_APPLICATION_PATHS.includes(path)

export const redirectToMemberApplications = () => {
  window.location.href = MEMBER_APPLICATIONS_URL
}

/**
 * api-v3 refuses the legacy create/update application mutations once
 * applications have moved to my.pga.com, with a message that starts "Please
 * apply at the new applications portal". The legacy form uses this to show a
 * pointer to the hub instead of the generic error page. It matches the phrase,
 * not the URL, because the URL in the message is prod-only. Remove with the
 * legacy form.
 */
export const isApplicationsMovedError = error =>
  /new applications portal/i.test(error?.message ?? "")
